
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import BenefitsSection from './components/BenefitsSection';
import ProcessSection from './components/ProcessSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://elpasoquickbooksbookkeeping.com/"
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <nav className="w-full px-6 py-4" aria-label="Main navigation">
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <div className="flex items-center">
              <a href="/" className="cursor-pointer">
                <h1 className="sr-only">
                  El Paso QuickBooks Bookkeeping Services
                </h1>
                <img
                  src="https://public.readdy.ai/ai/img_res/7a57d421-2c2a-46f2-8ebb-126e0217b520.png"
                  alt="El Paso QuickBooks Bookkeeping Services - Professional Bookkeeper in El Paso TX"
                  title="El Paso QuickBooks Bookkeeping Services"
                  className="h-12 w-auto"
                />
              </a>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a
                href="#services"
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled
                    ? 'text-gray-700 hover:text-teal-600'
                    : 'text-white hover:text-teal-300'
                }`}
              >
                Services
              </a>
              <a
                href="#benefits"
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled
                    ? 'text-gray-700 hover:text-teal-600'
                    : 'text-white hover:text-teal-300'
                }`}
              >
                Why Choose Us
              </a>
              <a
                href="#process"
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled
                    ? 'text-gray-700 hover:text-teal-600'
                    : 'text-white hover:text-teal-300'
                }`}
              >
                How It Works
              </a>
              <a
                href="#testimonials"
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled
                    ? 'text-gray-700 hover:text-teal-600'
                    : 'text-white hover:text-teal-300'
                }`}
              >
                Testimonials
              </a>
              <Link
                to="/blog"
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled
                    ? 'text-gray-700 hover:text-teal-600'
                    : 'text-white hover:text-teal-300'
                }`}
              >
                Blog
              </Link>
              <a
                href="#contact"
                className="bg-teal-500 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Started
              </a>
            </div>
          </div>
        </nav>
      </header>

      <main>
        <HeroSection />
        <FeaturesSection />
        <BenefitsSection />
        <ProcessSection />
        <TestimonialsSection />
        <CTASection />
      </main>

      <Footer />

      {/* JSON‑LD for Breadcrumbs */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      />
    </div>
  );
}
